export interface ItemQtyProps {
  maxValue?: number
  initialQuantity: number
  cartItem?: boolean
  disableIncrement?: boolean
}

export type ItemQtyEmitFn = {
  (e: 'add-to-cart' | 'qty-updated', value: number): void
  (e: 'remove-from-cart'): void
}

export const useItemQty = (props: ItemQtyProps, emit: ItemQtyEmitFn)  => {
  const value = ref(0)
  const max = 99
  const maxAllowed = computed(() => props.maxValue || max)
  const setInitial = () => { value.value = props.initialQuantity }
  const incrementDisabled = computed(() => value.value >= maxAllowed.value || props.disableIncrement)
  const decrementDisabled = computed(() => value.value <= 1)

  const increment = () => {
    if (value.value < maxAllowed.value) { value.value += 1 }
    emit('qty-updated', value.value)

    // match qty from backend. Needed for BOGO promotions where a discounted line item qty
    // may be updated on the backend instead of updating qty of the clicked line item
    if (props.cartItem) { setInitial() }
  }
  const decrement = () => {
    if (value.value === 1) {
      emit('remove-from-cart')
      return
    }

    value.value -= 1
    emit('qty-updated', value.value)

    // match qty from backend. Needed for BOGO promotions where a discounted line item qty
    // may be updated on the backend instead of updating qty of the clicked line item
    if (props.cartItem) { setInitial() }
  }
  const addToCart = (qty?: number) => {
    if (typeof qty === 'number') {
      value.value = qty
    }

    if (value.value > maxAllowed.value) {
      value.value = props.initialQuantity
    } else {
      emit('add-to-cart', value.value)
    }
  }
  const reset = () => {
    if (value.value === 0 || typeof value.value !== 'number') { setInitial() }
  }
  const checkMaxLimit = () => {
    if (value.value > maxAllowed.value) { value.value = maxAllowed.value }
  }

  onMounted(setInitial)

  return {
    value,
    increment,
    decrement,
    addToCart,
    reset,
    incrementDisabled,
    decrementDisabled,
    checkMaxLimit,
    setInitial
  }
}
